import React, { useEffect, useState, useContext } from 'react';
import { Typography, Skeleton, Container, Paper, Box, Stack, Chip } from '@mui/material';
import { useHookState } from './NotificationApiHook';
import { fetchPlaceData, fetchCitiesData } from './api';
import { useNavigate } from 'react-router-dom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import NavigationOutlinedIcon from '@mui/icons-material/NavigationOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import { PlaceContext } from '../contexts/PlaceContext';
import { useDatePickerStyles } from './DatePickerStyles';

function PlacePicker() {
  const { notificationState } = useHookState();
  const [placesData, setPlacesData] = useState(null);
  const [cityData, setCityData] = useState(null);
  const [cityId, setCityId] = useState(0);
  const navigate = useNavigate();
  const { styles } = useDatePickerStyles();
  const { setPlaceId } = useContext(PlaceContext);
  const getSplitTime = (timestamp) => {
    return timestamp?.replace(/"/g, '')?.split('+')[0]?.split(':');
  };
  const isAdmin = localStorage.getItem('role_id') === '1';
  const handlePlaceId = (place_id) => {
    localStorage.setItem('place_id', place_id);
    setPlaceId(place_id);
    navigate('/booking');
  };

  useEffect(() => {
    fetchCitiesData(notificationState)
      .then((data) => {
        setCityData(data);
      })
      .catch((err) => {
        console.error('Error fetching city data:', err);
      });

    fetchPlaceData(notificationState)
      .then((data) => {
        data.start_time = data?.start_time?.replace(/"/g, '')?.split('+')[0]?.split(':');
        data.start_time = data?.end_time?.replace(/"/g, '')?.split('+')[0]?.split(':');
        setPlacesData(data);
      })
      .catch((err) => {
        console.error('Error fetching place data:', err);
      });
  }, []);

  if (!placesData || !cityData) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  const handleChipClick = (cityId) => {
    console.log('cityId: ', cityId);
    setCityId(cityId);
  };

  return (
    <Box
      sx={{
        mt: 5,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        overflowX: 'auto',
        maxHeight: 'calc(100svh - 200px)',
        minHeight: 'calc(100svh - 200px)',
        ...styles.scrollbar,
      }}
    >
      <Stack
        direction='row'
        spacing={1}
        mb={5}
        sx={{ display: 'flex', justifyContent: 'center' }}
      >
        {cityData.map((city, index) => (
          <Chip
            key={index}
            label={city.city}
            variant={cityId === city.id ? 'filled' : 'outlined'}
            onClick={() => handleChipClick(city.id)}
            color='primary'
          />
        ))}
      </Stack>
      {placesData.map((place, index) => (
        <Paper
          key={index}
          elevation={3}
          sx={{
            p: 4,
            mb: 2,
            width: 350,
            display: cityId === 0 || place.city_id === cityId ? 'block' : 'none',
          }}
          onClick={() => {
            handlePlaceId(place.id);
          }}
        >
          <Typography
            variant='h6'
            sx={{ mb: 2 }}
          >
            {place.name}
          </Typography>

          <Stack
            direction='column'
            sx={{
              justifyContent: 'space-between',
            }}
          >
            <Stack
              direction='row'
              alignItems='center'
              gap={1}
              mb={2}
            >
              <NavigationOutlinedIcon />
              <Typography
                sx={{
                  fontSize: '0.9rem',
                }}
              >
                {`${place.address}`}
              </Typography>
            </Stack>
            <Stack
              direction='row'
              alignItems='center'
              gap={1}
              mb={2}
            >
              <PhoneIphoneOutlinedIcon />
              <Typography
                sx={{
                  fontSize: '0.9rem',
                }}
              >
                {`${place.phone}`}
              </Typography>
            </Stack>
            <Stack
              direction='row'
              alignItems='center'
              gap={1}
              mb={2}
            >
              <AccessTimeIcon />
              <Typography
                sx={{
                  fontSize: '0.9rem',
                }}
              >
                {getSplitTime(place.start_time)[0]}:{getSplitTime(place.start_time)[1]} -{' '}
                {getSplitTime(place.end_time)[0]}:{getSplitTime(place.end_time)[1]}
              </Typography>
            </Stack>
            {/* </Stack> */}
          </Stack>
        </Paper>
      ))}
    </Box>
  );
}

export default PlacePicker;
